// gérer le cas ou il n'y a pas besoin d'avoir de bouton car la description est petite

obj_moreDescMobile = {
    default_state : 'show_more', // show_more or show_less

    toggle : function() {
        let new_height = 'auto';
        let new_state = 'show_less';
        let to_display = '#showlesstext';
        let to_hide = '#showmoretext';
        if(this.default_state == 'show_less'){
            new_height = 20;
            new_state = 'show_more';
            to_display = '#showmoretext';
            to_hide = '#showlesstext';
        }
        $('.univers-top__desc').height(new_height);
        this.default_state = new_state;
        $(to_display).css('display', 'inline-flex');
        $(to_hide).toggle();
        
    },
    init : function() {
        // si la taille de la description le demande alors faire :
        if ($('.description-category').height() > 200) {
            $('.description-category').height(20);
            $('.description-category').css('overflow-y','clip');
            $('#showmorebutton').toggle();
            $('#showmorebutton').click(this.toggle);
        }
    }
};
$(document).ready(()=>{
    if ($('#showmorebutton').length > 0 && $(document).width() < 768) {
        obj_moreDescMobile.init();
    }
});